export default class Construct extends CustomEvent {
    constructor(caller, classname, model) {
        super('construct', {
            bubbles: false,
            detail: {
                caller,
                classname,
                model
            }
        });
    }
}
